import { Seo } from "../components/seo";
import { ButtonLink } from "../components/ui";

export default function NotFound() {
  return (
    <section className="not-found">
      <Seo title="Pagina niet gevonden | STAQL" description="Deze pagina bestaat niet of is verplaatst." />
      <div className="container">
        <span className="not-found__code">404</span>
        <h1>Deze pagina werkt even niet mee.</h1>
        <p>De pagina die je zoekt bestaat niet meer, is verplaatst of het adres klopt niet.</p>
        <div><ButtonLink to="/">Terug naar home</ButtonLink><ButtonLink to="/diensten" variant="secondary">Bekijk de diensten</ButtonLink></div>
      </div>
    </section>
  );
}
